import { defineComponent, computed } from 'vue';
import { EyeOutlined, LikeOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  name: 'ExcellentWorkCard',
  props: {
    work: {
      type: Object,
      required: true
    }
  },
  components: {
    EyeOutlined: EyeOutlined,
    LikeOutlined: LikeOutlined
  },
  setup: function (props, _a) {
    var emit = _a.emit;
    var viewCount = computed(function () {
      var work = props.work;
      var wan = Math.floor(work.viewCount / 1000);
      return wan > 0 ? "".concat(wan, "k+") : work.viewCount;
    });
    var thumbCount = computed(function () {
      var work = props.work;
      var wan = Math.floor(work.thumbCount / 1000);
      return wan > 0 ? "".concat(wan, "k+") : work.thumbCount;
    });
    var onCardClick = function () {
      emit('select', props.work);
    };
    return {
      viewCount: viewCount,
      thumbCount: thumbCount,
      onCardClick: onCardClick
    };
  }
});